import * as React from "react";
import { cn } from "@/lib/utils";

export interface InlineDrawerProps {
  open: boolean;
  children: React.ReactNode;
  className?: string;
}

export function InlineDrawer({ open, children, className }: InlineDrawerProps) {
  if (!open) return null;
  return (
    <div className={cn("border-t border-line bg-surface-1 px-6 py-3", className)}>{children}</div>
  );
}
